export default "__VITE_ASSET__Sn4auOYk__"